module.exports = __webpack_public_path__ + "images/img-NSE-swP.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/managers/61.jpg
// module id = 2020
// module chunks = 0